// import { APP_URL } from "../constants";

export const BASE_URL = `https://prudentapi.insuretech.com.ng/api`;
// export const BASE_URL = `http://63.250.41.88/api`;
// export const BASE_URL = `https://prudentdemoapi.insuretech.com.ng/api`;
// export const BASE_URL = `http://api.insuretech.com.ng/cis/api/v1`;

export const GET_TENANT_DETAILS = "/tenant";
export const LOGIN_URL = "/login";
export const RESET_PASSWORD = "/force/password/change";
export const CREATE_USER = "/create/user";
export const LOGOUT = "/logout";
export const OFFICE_URL = "/offices";
export const SEARCH_OFFICE = "/searchoffice";
export const APP_STATUS = "/status";
export const STATE_URL = "/states";
export const ROLES_URL = "/get/roles";
export const ADD_STAFF_PI = "/staff_personal_info";
export const ADD_STAFF_CI = "/staff_contact_info";
export const ADD_STAFF_EDI = "/staff_edu_info";
export const REMOVE_STAFF_EDI = "/staff_edu_info";
export const ADD_STAFF_EMI = "/staff_emp_info";
export const ADD_STAFF_GI = "/staff_garrantor_info";
export const ADD_STAFF_WI = "/staff_prev_work";
export const ADD_STAFF_NKI = "/staff_next_kin";
export const STAFF_LIST = "/get_staff";
export const STAFF_INFORMATION = "get_staff";
export const UPDATE_STAFF_PI = "/staff_personal_info";
export const UPDATE_STAFF_CI = "/staff_contact_info";
export const UPDATE_STAFF_EDI = "/staff_edu_info";
export const UPDATE_STAFF_EMI = "/staff_emp_info";
export const UPDATE_STAFF_NKI = "/staff_next_kin";
export const UPDATE_STAFF_WI = "/staff_prev_work";
export const UPDATE_STAFF_GI = "/staff_garrantor_info";
export const ACTIVATE_STAFF = "/activate/staff";
export const DEACTIVATE_STAFF = "/deactivate/staff";
export const ALL_USERS = "/on_line_users";
export const GET_ALL_USERS = "/get/users";
export const UPDATE_USER = "/update/user";
export const UNLOCK_USER = "/activate/lock";
export const GET_SINGLE_USER = "/view/user";
export const TRANSFER_CUSTOMER = "/transfer/customer";
export const GET_ALL_ROLES = "/get/all/roles";
export const CREATE_ROLE = "/create/role";
export const CREATE_PERMISSION = "/create/permission";
export const GET_PERMISSIONS = "/get/permission";
export const ASSIGN_PERMISSIONS = "/assign/permission";
export const GET_SINGLE_ROLE = "/view/role";
export const UPDATE_ROLE = "/edit/role";
export const ADD_INDIVIDUAL_CUSTOMER = "/customer/individual";
export const UPDATE_CUSTOMER_PERSONAL_INFO = "/update/customer/personal/info";
export const UPDATE_CUSTOMER_IDENTITY_INFO =
  "/update/customer/identification/info";
export const UPDATE_CUSTOMER_BUSINESS_INFO = "/update/customer/business/info";
export const UPDATE_CUSTOMER_NOK_INFO = "/update/customer/nok/info";
export const UPDATE_CORPORATE_CUSTOMER_BUSINESS_INFO =
  "/update/corporate/business/info";
export const UPDATE_CORPORATE_CUSTOMER_CONTACT_INFO =
  "/update/corporate/contact/info";
export const UPDATE_CORPORATE_CUSTOMER_IDENTITY_INFO =
  "/update/corporate/identity/info";
export const ADD_CORPORATE_CUSTOMER = "/customer/corporate";
export const MAKE_STAFF_USER = "/make/user";
export const ACTIVATE_USER = "/activate/users";
export const DEACTIVATE_USER = "/deactivate/users";
export const SEARCH_USER = "/searchuser";
export const ACTIVE_ROLES_URL = "/get/permissions/roles";
export const ACTIVATE_ROLE = "/activiate/role";
export const DEACTIVATE_ROLE = "/deactiviate/role";
export const SEARCH_ROLE = "/searchroles";
export const ADD_CHART_OF_ACCOUNTS = "/create/account";
export const GET_GL_GROUPS = "/get/group";
export const GET_PAGINATED_ACCOUNTS = "/show/accounts";
export const GET_ACCOUNTS = "/all/accounts";
export const EDIT_ACCOUNT = "/update/account";
export const CREATE_JOURNAL = "/create/journal";
export const SEARCH_JOURNALS = "/journal/filter";
export const GET_RELATED_TRANSACTION = "/get/journals";
export const REVERSE_TRANSACTION = "/reverse/journal/transaction";
export const GET_GL_ACCOUNTS = "/get/accounts";
export const CREATE_POLICY_CONFIG = "/create/policy";
export const GET_ALL_CORPERATE_CUSTOMERS = "get/all/corporate/customer";
export const GET_ALL_INDIVIDUAL_CUSTOMERS = "get/all/customer";
export const GET_SINGLE_CUSTOMERS = "/get/customer";
export const APPROVE_CUSTOMER = "/approve/customer/status";
export const REJECT_CUSTOMER = "/reject/customer/status";
export const CLOSE_CUSTOMER = "/close/customer/status";
export const REACTIVATE_CUSTOMER = "/reactivate/customer/status";
export const FILTERED_CORPERATE_CUSTOMERS = "/filter/customer";
export const GET_ALL_POLICIES = "/get/all/policy";
export const GET_ALL_ACTIVE_POLICIES = "/get/all/active/policy";
export const GET_ALL_ACTIVE_SAVINGS_POLICIES = "/get-all-active-savings-policy";
export const GET_POLICY = "/get/single/policy/";
export const GET_UPDATE = "/update/policy/";
export const GET_FILTERED_POLICIES = "/search/all/policy";
export const ADD_OTHER_DOCS = "/create/corporate/other/document";
export const GET_ATTACHED_POLICY_CUSTOMER = "/attachpolicy/customer";
export const GET_SEARCHED_CORP_CUSTOMER = "/search/corporate/customer";
export const GET_SEARCHED_IND_CUSTOMER = "/search/customer";
export const GET_CUSTOMER_ACTIVE_POLICY = "/get/all/customer/active/policies";
export const CREATE_CLAUSE = "/create/policy/clause";
export const GET_ALL_CLAUSES = "/get/all/policy/clause";
export const GET_SINGLE_CLAUSES = "/get/single/policy/clause";
export const UPDATE_CLAUSE = "/update/policy/clause";
export const ATTACH_POLICY = "/policy/application";
export const GET_SINGLE_APPLIED_POLICY_COVERS = "/get/cover";
export const DELETE_COVER = "/delete/cover";
export const CREATE_COMMISSION = "/create/comission";
export const CREATE_SEGMENTED_COMMISSION = "/create/comission/segmentation";
export const GET_ALL_COMMISSIONS = "/get/all/comissions";
export const GET_SINGLE_COMMISSION = "view/single/comission";
export const UPDATE_DIRECT_COMMISSION = "/update/direct/comission";
export const UPDATE_SEGMENTED_COMMISSION = "/update/segemented/comission";
export const DELETE_CHART_OF_ACCOUNT = "/delete/account";
export const GET_APPLIED_POLICIES = "/appliedpolicy/all";
export const FILTER_APPLIED_POLICIES = "/filter/appliedpolicy";
export const SEARCH_APPLIED_POLICIES = "/search/appliedpolicy";
export const VIEW_CUSTOMER_POLICIES = "/policy/application/details";
export const GET_SINGLE_POLICY_DETAILS = "/single/appliedpolicy";
export const GET_SINGLE_APPLIED_POLICY_DETAILS = "/single/edit/applied/policy";
export const EDIT_SINGLE_APPLIED_POLICY_DETAILS = "/update/applied/policy";
export const VIEW_CUSTOMER_SING_POLICY_DETAIL = "/policy/application/details";
export const CHANGE_PASSWORD = "/change/password";
export const GET_DASH_DETAILS = "admin/dashboard/stat";
export const GET_LOGGEDIN_USERS = "/get/login/user";
export const GET_DATA_FOR_UNDER_WRITERING = "/underwriter/policy/details";
export const SUBMIT_UNDER_WRITERING = "/submit/underwriter";
export const GET_ACTION_ACTIVITIES = "/get/activity/action";
export const GET_USER_ACTIVITIES = "/get/activity";
export const GET_CUSTOMER_OVERVIEW = "/get/customer/overview";
export const GET_CUSTOMER_PAYMENT = "/get/customer/payment";
export const GET_CUSTOMER_POLICY_INFO = "/get/customer/policyinfo";
export const GET_RENEWED_POLICY = "/renewed-policy";
export const GET_INDIVIDUAL_SAVINGS_REPORT = "/individual/savings/report";
export const GET_SAVINGS_ACCOUNT_REPORT = "/savings/prdouct/report";
export const GET_SAVINGS_CLAIM_REPORT = "/savings/claim/report";
export const GET_SAVINGS_CONTRIBUTION_REPORT = "/savings/contribution/report";
export const GET_AGENT_REPORT = "/get-agent-data";
export const GET_CLAIM_REPORT = "/get-claim-data";
export const GET_TRIAL_BALANCE = "/get-trial-balance";
export const GET_CUSTOMER_POLICY_EXPIRY = "/policy/expiry-renewal";
export const GET_OVERVIEW_DATA = "/get-report-data";
export const MAKE_PAYMENT = "/post/customer/payment";
export const MAKE_SAVINGS_PAYMENT = "/submit/savings/payment";
export const REVERSE_CUSTOMER_TRANSACTION = "/reverse/customer/transaction";
export const REVERSE_SAVINGS_TRANSACTION = "/savings/payment/reversal";
export const SINGLE_POLICY_COVER = "/get/cover";
export const POLICY_COVER_BY_CATEGORY = "/policycategory/get/cover";
export const COVER = "/add/cover";
export const GET_COVER = "/get/cover";
export const GET_SINGLE_COVER = "/edit/cover";
export const UPDATE_COVER = "/update/cover";
export const CREATE_WORKFLOW = "/workflow/create";
export const GET_ALL_WORKFLOWS = "/workflow/get";
export const GET_SINGLE_WORKFLOWS = "/workflow/view";
export const UPDATE_SINGLE_WORKFLOW = "/workflow/update";
export const POLICYHOLDER_INFO = "/claim/policyholder/info";
export const CATEGORY_ACTIVE_POLICY = "/claim/category/active/policy";
export const CREATE_CLAIM_SETTINGS = "/create/claim_setting";
export const GET_ALL_CLAIM_SETTINGS = "/getall/claim_setting";
export const GET_SINGLE_CLAIM_SETTINGS = "/view/claim_setting";
export const UPDATE_CLAIM_SETTINGS = "/update/claim_setting";
export const CUSTOM_FORM = "/create/customform";
export const GET_CUSTOM_FORM = "/get/allform";
export const VIEW_CUSTOM_FORM = "/view/form";
export const UPDATE_CUSTOM_FORM = "/update/form";
export const GET_CLAIM_PROCESS_SETTINGS = "/get/claim_setting/process";
export const CREATE_CLAIM = "/claim/create/process";
export const GET_CLAIMS = "/claim/getall/process";
export const GET_SINGLE_CLAIM = "/claim/single/process";
export const UPDATE_CLAIM = "/claim/update/process";
export const DECLINE_CLAIM = "/claim/decline/process";
export const APPROVE_CLAIM = "/claim/approve/process";
export const GET_CUSTOMER_CLAIMS = "/viewclaim";
export const GET_CLAIM_COMMENTS = "/get/claim/comments";
export const GET_FILTERED_CLAIMS = "/search/process";
export const RENEW_SINGLE_APPLIED_POLICY_DETAILS = "/policy/renewal";
export const GET_POLICY_CIRCLES = "/get/policy/history";
export const GET_SINGLE_POLICY_HISTORY_DETAILS = "/view/single/policy/history";
export const GET_POLICY_DOCUMENT = "/generate/policy/document";
export const GET_POLICY_SCHEDULE_DOC = "/generate/schedule/document";
export const GET_PENDING_CLAIM_ACTIONS = "/pending-actions-claim";
export const CREATE_CHARGE = "/create-charge";
export const GET_ALL_CHARGE = "/get-all-charge";
export const GET_SINGLE_CHARGE = "/edit-charge";
export const UNPAGINATED_CHARGES = "/get-saving-charges";
export const UPDATE_CHARGE = "/update-charge";
export const CREATE_SAVINGS_POLICY_CONFIG = "/create-savings-policy";
export const GET_SAVINGS_POLICY = "/get-all-savings-policy";
export const GET_SINGLE_SAVINGS_POLICY = "/single-savings-policy";
export const UPDATE_SAVINGS_POLICY = "/update-savings-policy";
export const GET_SAVINGS_POLICY_COVER = "/policy/savings/cover";
export const GET_SAVINGS_POLICY_CONFIG = "/saving/config/info";
export const GET_ACTIVE_SAVINGS_POLICIES = "/get-all-active-savings-policy";
export const CREATE_CUSTOMER_SAVINGS_POLICY = "/savings/policy/application";
export const GET_APPLIED_SAVINGS_POLICIES = "/all/applied/savpolicy";
export const FILTER_SAVINGS_POLICIES = "/filter/applied/savpolicy";
export const GET_SINGLE_APPLIED_SAVINGS_POLICIES =
  "/single/saving/appliedpolicy";
export const EDIT_SINGLE_SAVINGS_APPLIED_POLICY =
  "/edit/savings/policy/application";
export const GET_SAVINGS_POLICYHOLDER = "/savings/claim/policyholder/info";
export const GET_SAVINGS_CLAIM_DETAILS = "/get/savings/claim/details";
export const CREATE_SAVINGS_CLAIM = "/create/savings/claim/process";
export const GET_ALL_SAVINGS_CLAIM = "/get/all/savings/claim";
export const GET_SINGLE_SAVINGS_CLAIM = "/get/single/savings/claim";
export const UPDATE_SAVINGS_CLAIM = "/update/savings/claim/process";
export const APPROVE_SAVINGS_CLAIM = "/approve/savings/claim/process";
export const DECLINE_SAVINGS_CLAIM = "/decline/savings/claim/process";

// savings policies underwriting
export const GET_SAVINGS_POLICY_UNDERWRITING =
  "/underwriter/sav/policy/details";
export const GET_SAVINGS_POLICY_DOCUMENT =
  "/generate/savings/schedule/document";
export const SUBMIT_SAVINGS_UNDER_WRITERING = "/submit/savapp/underwrite";
export const CREATE_LIFE_COVER = "create-life-cover";
export const VIEW_LIFE_COVER = "edit-life-cover";
export const UPDATE_LIFE_COVER = "update-life-cover";
export const GET_ALL_LIFE_COVER = "get-all-life-cover";

// migration endpoints
export const USER_MIGRATION = "import/user";
export const STAFF_MIGRATION = "import/staff/details";
export const CUSTOMER_MIGRATION = "import/customer/details";
export const CUSTOMER_TRANSACTION_MIGRATION = "import/customer/transaction";
export const CUSTOMER_CLAIM_MIGRATION = "import/customer/claim";
export const POLICY_APP_DETAILS_MIGRATION = "import/policyapp/details";
export const POLICY_APP_RISK_MIGRATION = "import/policyapp/risk";
export const JORNAL_ENTRY_MIGRATION = "import/journal/entry";
export const CHATS_OF_ACCOUNT_MIGRATION = "import/account";
export const SAVINGS_APP_MIGRATION = "import/savings/application";

//coinsurance
export const ADD_COINSURANCE = "/co-insurance";
export const GET_ALL_COINSURANCE = "/co-insurance";
export const GET_SINGLE_COINSURANCE = "/co-insurance";
export const UPDATE_COINSURANCE = "/co-insurance";
